import { createContext, useContext } from 'react';

/**
 * Shared by the slide-in provider and the invoice column. The column reads
 * the slot element; the footer writes it. Split from the components so the
 * component file only exports components.
 */
export const InvoiceSlideinActionsContext = createContext<HTMLElement | null>(
  null,
);

export const InvoiceSlideinActionsSlotContext = createContext<
  (slot: HTMLElement | null) => void
>(() => {});

export function useInvoiceSlideinActionsSlot(): HTMLElement | null {
  return useContext(InvoiceSlideinActionsContext);
}
